import { CapTableRail } from '@dealstack/shared/lib/generated';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';
import { LabeledSegmentedControl } from '@dealstack/frontend/shared/components/LabeledSegmentedControl/LabeledSegmentedControl.tsx';

interface Props {
	rail: CapTableRail;
	setRail: (rail: CapTableRail) => void;
}

// CAP-1972 / CAP-1973: nominee-structure Beneficial/Legal title-rail switcher, rendered above the
// Cap Table, the Group Structure Chart and a legal person's Ownership table (only when
// deal.hasNomineeStructure). Beneficial is the default rail. Reuses the shared
// LabeledSegmentedControl so it stays identical to the adjacent "View" switch and matches the
// Figma "Switcher - Toggle" node (32293:242887) — no bespoke styling here.
export const TitleRailToggle = ({ rail, setRail }: Props) => {
	const tCommonUi = useTranslationCommonUi();

	return (
		<LabeledSegmentedControl<CapTableRail>
			data-testid={TEST_ELEMENT_IDS.CAP_TITLE_RAIL_TOGGLE}
			label={tCommonUi('title_rail.label', { defaultValue: 'Interest' })}
			value={rail}
			onChange={setRail}
			data={[
				{
					value: CapTableRail.BENEFICIAL,
					label: tCommonUi('title_rail.beneficial', {
						defaultValue: 'Beneficial',
					}),
				},
				{
					value: CapTableRail.LEGAL,
					label: tCommonUi('title_rail.legal', { defaultValue: 'Legal' }),
				},
			]}
		/>
	);
};
